export enum LocalStorageKeys {
    currentRunningGameTab = 'cgp_CURRENT_RUNNING_GAME_TAB',
    currentRunningGameType = 'cgp_CURRENT_RUNNING_GAME_TYPE',
    uccMessages = 'cgp_ucc'
}